function HomeManagementController(){
    this.className			= "HomeManagementController";
    this.glob				= ["/home-management**"];
}
HomeManagementController.inheritsFrom( PageController );
HomeManagementController.prototype.swap = function(onComplete){

    this.baseController  = Aviator.get("baseController")
    this.topicController = Aviator.get("topicController");

    this.topicController.scrollToFees();

    this.configTopicImageSymbolAnimation();

    this.imageController = this.baseController.getImageController();
    this.imageLoadedOrFailedDelegate =  (e) => {
        if(!e.image) return; //Early ones aren't ready with an image
        this.animationControllers.forEach(a => a.refresh());
    };

    this.imageController.addListener("refresh",this.imageLoadedOrFailedDelegate);
    this.imageController.addListener("failed",this.imageLoadedOrFailedDelegate);

    Preloader2.add("/assets/images/backgrounds/planks.svg").then(() => {
        //Add a delay to all it to render
        setTimeout(() => onComplete(), 10);
    });

    return false;
}
HomeManagementController.prototype.on = function(onComplete){

    return true;
}
HomeManagementController.prototype.off = function(onComplete){
    if(this.imageController){
        if(this.imageLoadedOrFailedDelegate) this.imageController.removeListener("refresh",this.imageLoadedOrFailedDelegate);
        if(this.imageLoadedOrFailedDelegate) this.imageController.removeListener("failed",this.imageLoadedOrFailedDelegate);
    }
    this.animationControllers?.forEach(ac => {
        ac.destroy();
    });
    this.animationControllers = [];

    return true;
}
HomeManagementController.prototype.configTopicImageSymbolAnimation = function () {

    if (this.log) console.log(`%c[HomeManagementController]`, 'background:cyan', `configTopicImageSymbolAnimation`);

    this.animationControllers = [];

    const topicImageSymbolList = document.querySelectorAll('.topic-image-symbol');
    topicImageSymbolList.forEach((topicImageSymbol, index) => {
        const containerSelector = `#topic-image-symbol-${index}`;

        const startX = (index%2==0) ? 8 : -8;
        const topicSymbols = [
            {
                selector: `${containerSelector} .topic-symbol`,
                start: {
                    x: startX,
                    y: 0
                },
                end: {
                    x: 0,
                    y: 0
                },
                duration: 1,
            },
        ]


        var animationController = new AnimationController({
            containerSelector: containerSelector,
            items: topicSymbols,
            triggerStart: 'top bottom',
            triggerEnd: 'top 30%',
            showMarkers: false
        });

        this.animationControllers.push(animationController);
    })


}